/**
 * Ameen UI signals and follow-up instruction strings.
 * Single source of truth for runtime message strings the frontend sends via client.send().
 * Agent system instructions come from the backend; these are the [system_ui] and [SYSTEM INSTRUCTION] values only.
 */

// ─── Prefixes ─────────────────────────────────────────────────────────────────
export const SYSTEM_UI_PREFIX = '[system_ui] ';
export const SYSTEM_INSTRUCTION_PREFIX = '[SYSTEM INSTRUCTION] ';

// ─── Signal event names (no prefix) ───────────────────────────────────────────
export const USER_CLICKED_PACKAGE_CONFIRM = 'user_clicked_package_confirm';
export const USER_SELECTED_LIVE_SURVEY = 'user_selected_live_survey';
export const USER_SELECTED_UPLOAD_IMAGES = 'user_selected_upload_images';

export const USER_UPLOADED_NATIONAL_ID_FRONT = 'user_uploaded_national_id_front';
export const USER_UPLOADED_NATIONAL_ID_BACK = 'user_uploaded_national_id_back';
export const USER_UPLOADED_DRIVING_LICENSE = 'user_uploaded_driving_license';
export const USER_UPLOADED_VEHICLE_LICENSE_FRONT = 'user_uploaded_vehicle_license_front';
export const USER_UPLOADED_VEHICLE_LICENSE_BACK = 'user_uploaded_vehicle_license_back';
export const VEHICLE_LICENSE_MAKE_MODEL_MISMATCH = 'vehicle_license_make_model_mismatch';

export const USER_UPLOADED_VEHICLE_IMAGES = 'user_uploaded_vehicle_images';

/** User captured one vehicle survey side via the capture button (same as take_vehicle_picture). Payload = side name (Chassis, Front, Right, Back, Left). */
export const USER_CAPTURED_VEHICLE_SIDE = 'user_captured_vehicle_side';

export const USER_CLICKED_POLICY_CONFIRM = 'user_clicked_policy_confirm';
export const USER_SUBMITTED_POLICY_INQUIRY = 'user_submitted_policy_inquiry';

export const USER_SELECTED_CONTRACTED_WORKSHOP = 'user_selected_contracted_workshop';
export const USER_SELECTED_NON_CONTRACTED_WORKSHOP = 'user_selected_non_contracted_workshop';
export const USER_CHOSE_CONTRACTED_WORKSHOP = 'user_chose_contracted_workshop';
export const USER_SUBMITTED_NON_CONTRACTED_WORKSHOP = 'user_submitted_non_contracted_workshop';
export const USER_ACKNOWLEDGED_CLAIM_NUMBER = 'user_acknowledged_claim_number';

// Underwriting question answers
export const USER_ANSWERED_VEHICLE_USAGE = 'user_answered_vehicle_usage';
export const USER_ANSWERED_HAD_ACCIDENT = 'user_answered_had_accident';
export const USER_ANSWERED_NIGHT_PARKING = 'user_answered_night_parking';
export const USER_ANSWERED_VIOLATIONS = 'user_answered_violations';
export const USER_ANSWERED_TRACKING_DEVICE = 'user_answered_tracking_device';
export const USER_ANSWERED_VEHICLE_FINANCING = 'user_answered_vehicle_financing';
export const USER_ANSWERED_NUMBER_OF_DRIVERS = 'user_answered_number_of_drivers';

export const PHOTO_VALIDATION_FAILED_PREFIX = 'photo_validation_failed_';

// ─── Helper ───────────────────────────────────────────────────────────────────
export function systemUiMessage(event: string, payload?: string): string {
  if (payload != null && payload !== '') {
    return `${SYSTEM_UI_PREFIX}${event}: ${payload}`;
  }
  return `${SYSTEM_UI_PREFIX}${event}`;
}

// ─── Document upload: map flowStep to signal event (for fallback / photo validation) ─
const FLOW_STEP_TO_EVENT: Record<string, string> = {
  national_id_front: USER_UPLOADED_NATIONAL_ID_FRONT,
  national_id_back: USER_UPLOADED_NATIONAL_ID_BACK,
  driving_license: USER_UPLOADED_DRIVING_LICENSE,
  vehicle_license_front: USER_UPLOADED_VEHICLE_LICENSE_FRONT,
  vehicle_license_back: USER_UPLOADED_VEHICLE_LICENSE_BACK,
};

export function getDocumentUploadEventForFlowStep(flowStep: string): string | undefined {
  return FLOW_STEP_TO_EVENT[flowStep];
}
